import { createTheme } from '@mui/material/styles';
import './index.css'

const theme = createTheme({
  palette: {
    primary: {
      main: '#D9480F',
      dark:"#344054",
      light:"#D0D5DD",
      contrastText:"#101828",

    },
    secondary:{
      main:"#667085",

    },
    warning:{
      main:"#D32028",
      light:"#FFEDEE",
    },
    grey:{
      main:"#E9E9E9",
    },

    error: {
      main: "#FF0000",
    },
  },

});


// theme.typography.h1 = {
//   fontSize: "104px",
//   fontFamily:"Gilroy-Bold",
//   lineHeight:"100%",
//   [theme.breakpoints.down('sm')]: {
//     fontSize: '30px',
//   },
// };
// theme.typography.h2 = {
//   fontSize: "56px",
//   fontFamily:"Gilroy-Bold",
//   lineHeight:"64px",
//   [theme.breakpoints.down('sm')]: {
//     fontSize: '30px',
//   },
// };
// theme.typography.h3 = {
//   fontSize: "40px",
//   fontFamily:"Gilroy-Bold",
//   lineHeight:"44px",
//   [theme.breakpoints.down('xs')]: {
//     fontSize: '20px',
//   },
// };
theme.typography.h4 = {
  fontSize: "30px",
  fontFamily:"Inter-Medium",
  lineHeight:"24px",
  // [theme.breakpoints.down('md')]: {
  //   fontSize: '2.4rem',
  // },
};
theme.typography.h5 = {
  fontSize: "26px",
  fontFamily:"Inter-Bold",
  lineHeight:"38px",
  // [theme.breakpoints.down('md')]: {
  //   fontSize: '2.4rem',
  // },
};
theme.typography.h6 = {
  fontSize: "24px",
  fontFamily:"Inter-Bold",
  lineHeight:"24px",
  // [theme.breakpoints.down('md')]: {
  //   fontSize: '2.4rem',
  // },
};
theme.typography.body1 = {
  fontSize: "16px",
  fontFamily:"Inter-Bold",
  lineHeight:"40px",
  // [theme.breakpoints.down('md')]: {
  //   fontSize: '2.4rem',
  // },
};
theme.typography.body2 = {
  fontSize: "14px",
  fontFamily:"Inter-Medium",
  lineHeight:"22px",
  color:theme.palette.primary.contrastText,
  // [theme.breakpoints.down('md')]: {
  //   fontSize: '2.4rem',
  // },
};
export const fibeTokens = {
  color: {
    primary: '#DC2626',
    primaryHover: '#B91C1C',
    primaryPressed: '#991B1B',
    primaryTint: '#FEF2F2',
    primaryTintBorder: '#FEE2E2',
    textPrimary: '#101828',
    textSecondary: '#344054',
    textMuted: '#667085',
    textDisabled: '#98A2B3',
    border: '#EAECF0',
    borderStrong: '#D0D5DD',
    surface: '#FFFFFF',
    pageBg: '#F8FAFC',
    rowHover: '#FAFAFB',
    success: '#067647',
    danger: '#B42318',
    dangerBorder: '#FDA29B',
    info: '#175CD3',
    infoTint: '#F5FAFF',
    infoBorder: '#B2DDFF',
    warning: '#B54708',
    warningTint: '#FFFAEB',
    successTint: '#F6FEF9',
    dangerTint: '#FFFBFA',
    trackBg: '#F2F4F7',
    dangerIconTint: '#FEF3F2',
  },
  font: {
    family: 'Inter, sans-serif',
    heading: { fontWeight: 700, fontSize: 32, lineHeight: 1.2, letterSpacing: '-0.02em' },
    pageTitle: { fontWeight: 700, fontSize: 28, lineHeight: 1.2, letterSpacing: '-0.02em' },
    pageSubtitle: { fontWeight: 400, fontSize: 12.5, color: '#667085' },
    sectionHeading: { fontWeight: 600, fontSize: 14 },
    cardTitle: { fontWeight: 600, fontSize: 14 },
    primaryMetric: { fontWeight: 700, fontSize: 42, lineHeight: 1.1, letterSpacing: '-0.02em', fontVariantNumeric: 'tabular-nums' },
    kpiValue: { fontWeight: 600, fontSize: 26, lineHeight: 1, fontVariantNumeric: 'tabular-nums', letterSpacing: '-0.025em' },
    kpiLabel: { fontWeight: 600, fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#667085' },
    tableHeader: { fontWeight: 600, fontSize: 14, color: '#101828' },
    tableCell: { fontWeight: 400, fontSize: 14, color: '#667085' },
    fieldLabel: { fontWeight: 500, fontSize: 11.5, color: '#344054' },
    body: { fontWeight: 400, fontSize: 14, lineHeight: 1.6, color: '#344054' },
    helper: { fontWeight: 400, fontSize: 13, lineHeight: 1.5, color: '#98A2B3' },
    caption: { fontWeight: 400, fontSize: 13, lineHeight: 1.5, color: '#98A2B3' },
  },
  spacing: { xs: 4, sm: 8, md: 16, lg: 24, xl: 32, xxl: 40 },
  density: {
    tableRowHeight: 44,
    tableHeaderHeight: 40,
    cellPaddingX: 16,
    cardPadding: '20px 24px',
    cardHeaderPadding: '16px 24px',
    cardRadius: 16,
    cardBorder: '1px solid #EEF2F7',
    cardShadow: '0 2px 10px rgba(16,24,40,.04)',
    cardHoverShadow: '0 14px 30px rgba(16,24,40,.08)',
    cardHoverTransform: 'translateY(-2px)',
    gridGap: 16,
  },
  pipelineBar: {
    billable: '#12B76A',
    pending: '#98A2B3',
    held: '#F79009',
    forfeited: '#F04438',
  },
  dialog: {
    shadow: '0 16px 40px -16px rgba(16,24,40,.28)',
    footerBg: '#FCFCFD',
    footerBorder: '#F0F1F4',
    icon: {
      red: { background: '#FEF2F2', border: '#FEE2E2', color: '#DC2626' },
      blue: { background: '#F5FAFF', border: '#B2DDFF', color: '#175CD3' },
      green: { background: '#F6FEF9', border: '#ABEFC6', color: '#067647' },
      danger: { background: '#FFFBFA', border: '#FECDCA', color: '#B42318' },
    },
  },
  iconContainer: {
    size: 48,
    radius: 14,
    tones: {
      red: { background: '#FEF2F2', color: '#DC2626' },
      blue: { background: '#EFF8FF', color: '#175CD3' },
      green: { background: '#F0FDF4', color: '#16A34A' },
      amber: { background: '#FFFBEB', color: '#B45309' },
      purple: { background: '#FAF5FF', color: '#7E22CE' },
      grey: { background: '#F8FAFC', color: '#475569' },
      teal: { background: '#F0FDFA', color: '#0F766E' },
      rose: { background: '#FDF2F8', color: '#BE185D' },
    },
  },
  drawer: {
    width: 440,
    shadow: '-16px 0 40px -16px rgba(16,24,40,.18)',
    headerPadding: '20px 24px',
    bodyPadding: '24px',
  },
  filterBar: {
    background: '#FFFFFF',
    border: '1px solid #EAECF0',
    radius: 12,
    padding: '14px 18px',
    gap: 12,
  },
  tabs: {
    indicatorHeight: 2,
    containerSx: {
      minHeight: 56,
      height: 56,
      background: '#FFFFFF',
      borderBottom: '1px solid #EAECF0',
      px: '24px',
    },
    tabSx: {
      minHeight: 56,
      height: 56,
      padding: '0 20px',
      fontWeight: 500,
      fontSize: 13.5,
      textTransform: 'none',
      color: '#667085',
      transition: 'color .14s ease, background-color .14s ease',
      '&:hover': { color: '#101828', background: '#FAFAFB' },
      '&.Mui-selected': {
        color: '#DC2626',
        fontWeight: 600,
        background: 'linear-gradient(180deg, #FEF7F7 0%, #FEF2F2 100%)',
      },
      '&:focus-visible': { outline: '2px solid #DC2626', outlineOffset: -2 },
    },
  },
};

const fibeButtonBase = {
  fontFamily: 'Inter-Medium, sans-serif',
  fontWeight: 500,
  fontSize: 13,
  height: 42,
  padding: '0 18px',
  borderRadius: 10,
  gap: 7,
  border: '1px solid transparent',
  textTransform: 'none',
  transition: 'background-color .14s ease, border-color .14s ease, box-shadow .14s ease, color .14s ease, transform .14s ease',
  '&:focus-visible': { outline: '2px solid #DC2626', outlineOffset: 2 },
};
const fibeButtonSmall = {
  height: 30,
  padding: '0 10px',
  fontSize: 11.5,
  borderRadius: 8,
  gap: 5,
};
const fibeButtonDisabled = {
  '&.Mui-disabled': { backgroundColor: '#F9FAFB', color: '#C0C6D0', border: '1px solid #EAECF0', boxShadow: 'none' },
};

theme.components = {
  MuiButton: {
    styleOverrides: {
      containedPrimary: {
        transition: 'background-color .15s ease, box-shadow .15s ease, transform .15s ease',
        '&:hover': {
          backgroundColor: '#B83D0D',
          color: '#fff',
          boxShadow: '0 4px 12px rgba(217,72,15,.28)',
          transform: 'translateY(-1px)',
        },
      },
    },
    variants: [
      { props: { variant: 'fibePrimary' }, style: { ...fibeButtonBase, ...fibeButtonDisabled, backgroundColor: '#DC2626', color: '#fff', boxShadow: '0 1px 2px rgba(16,24,40,.1), inset 0 1px 0 rgba(255,255,255,.16)', '&:hover': { backgroundColor: '#B91C1C', boxShadow: '0 4px 10px rgba(220,38,38,.24)' }, '&:active': { backgroundColor: '#991B1B', boxShadow: 'inset 0 1px 2px rgba(0,0,0,.2)' } } },
      { props: { variant: 'fibePrimary', size: 'small' }, style: fibeButtonSmall },
      { props: { variant: 'fibeSecondary' }, style: { ...fibeButtonBase, ...fibeButtonDisabled, backgroundColor: '#fff', color: '#344054', borderColor: '#D0D5DD', boxShadow: '0 1px 2px rgba(16,24,40,.05)', '&:hover': { backgroundColor: '#F9FAFB', borderColor: '#98A2B3', color: '#101828', boxShadow: '0 2px 6px rgba(16,24,40,.08)' }, '&:active': { backgroundColor: '#F2F4F7', boxShadow: 'inset 0 1px 2px rgba(16,24,40,.08)' } } },
      { props: { variant: 'fibeSecondary', size: 'small' }, style: fibeButtonSmall },
      { props: { variant: 'fibeGhost' }, style: { ...fibeButtonBase, backgroundColor: 'transparent', color: '#667085', '&:hover': { backgroundColor: '#F2F4F7', color: '#344054' } } },
      { props: { variant: 'fibeGhost', size: 'small' }, style: fibeButtonSmall },
      { props: { variant: 'fibeSuccess' }, style: { ...fibeButtonBase, ...fibeButtonDisabled, backgroundColor: '#067647', color: '#fff', boxShadow: '0 1px 2px rgba(16,24,40,.1), inset 0 1px 0 rgba(255,255,255,.16)', '&:hover': { backgroundColor: '#05603A', boxShadow: '0 4px 10px rgba(6,118,71,.24)' } } },
      { props: { variant: 'fibeSuccess', size: 'small' }, style: fibeButtonSmall },
      { props: { variant: 'fibeDangerOutline' }, style: { ...fibeButtonBase, backgroundColor: '#fff', color: '#B42318', borderColor: '#FDA29B', '&:hover': { backgroundColor: '#FEF3F2', borderColor: '#F97066' } } },
      { props: { variant: 'fibeDangerOutline', size: 'small' }, style: fibeButtonSmall },
      { props: { variant: 'fibeDangerSolid' }, style: { ...fibeButtonBase, ...fibeButtonDisabled, backgroundColor: '#B42318', color: '#fff', boxShadow: '0 1px 2px rgba(16,24,40,.1), inset 0 1px 0 rgba(255,255,255,.16)', '&:hover': { backgroundColor: '#912018' } } },
      { props: { variant: 'fibeDangerSolid', size: 'small' }, style: fibeButtonSmall },
    ],
  },
  MuiOutlinedInput: {
    variants: [
      {
        props: { size: 'fibeMd' },
        style: {
          height: 42, borderRadius: 10, backgroundColor: '#fff',
          fontFamily: 'Inter-Medium, sans-serif', fontSize: 13, color: '#101828',
          '& .MuiOutlinedInput-input': { padding: '0 13px', height: '100%', boxSizing: 'border-box', display: 'flex', alignItems: 'center' },
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#D0D5DD' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#98A2B3' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#DC2626', boxShadow: '0 0 0 3px rgba(220,38,38,.12)' },
        },
      },
      {
        props: { size: 'fibeSm' },
        style: {
          height: 30, borderRadius: 8, backgroundColor: '#fff', fontSize: 11.5,
          '& .MuiOutlinedInput-input': { padding: '0 11px', height: '100%', boxSizing: 'border-box', display: 'flex', alignItems: 'center' },
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#D0D5DD' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#98A2B3' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#DC2626', boxShadow: '0 0 0 3px rgba(220,38,38,.12)' },
        },
      },
      {
        props: { size: 'fibeFlatSm' },
        style: {
          height: 30, borderRadius: 8, backgroundColor: '#F9FAFB', fontSize: 11.5,
          '& .MuiOutlinedInput-input': { padding: '0 11px', height: '100%', boxSizing: 'border-box', display: 'flex', alignItems: 'center' },
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#EAECF0' },
          '&:hover': { backgroundColor: '#fff' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#98A2B3' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#DC2626', boxShadow: '0 0 0 3px rgba(220,38,38,.12)' },
        },
      },
    ],
  },
  MuiChip: {
    variants: [
      { props: { variant: 'fibePill' }, style: { borderRadius: 999, fontWeight: 600, fontSize: 11, height: 'auto', '& .MuiChip-label': { padding: '3px 9px' } } },
      { props: { variant: 'fibePill', color: 'success' }, style: { backgroundColor: '#F6FEF9', color: '#067647', border: '1px solid #ABEFC6' } },
      { props: { variant: 'fibePill', color: 'warning' }, style: { backgroundColor: '#FFFAEB', color: '#B54708', border: '1px solid #FEDF89' } },
      { props: { variant: 'fibePill', color: 'error' }, style: { backgroundColor: '#FFFBFA', color: '#B42318', border: '1px solid #FECDCA' } },
      { props: { variant: 'fibePill', color: 'default' }, style: { backgroundColor: '#F9FAFB', color: '#475467', border: '1px solid #E4E7EC' } },
      { props: { variant: 'fibePill', color: 'info' }, style: { backgroundColor: '#F5FAFF', color: '#175CD3', border: '1px solid #B2DDFF' } },
      { props: { variant: 'fibePill', color: 'secondary' }, style: { backgroundColor: '#FAFAFF', color: '#5925DC', border: '1px solid #D9D6FE' } },
      { props: { variant: 'fibePillZoho' }, style: { borderRadius: 999, fontWeight: 600, fontSize: 11, height: 'auto', backgroundColor: '#F2FBF6', color: '#0C7E44', border: '1px solid #B7E3CB', '& .MuiChip-label': { padding: '3px 9px' } } },
    ],
  },
  MuiTableCell: {
    variants: [
      { props: { size: 'fibe', variant: 'head' }, style: { height: 40, padding: '0 16px', backgroundColor: '#F9FAFB', borderBottom: '1px solid #EAECF0', fontWeight: 600, fontSize: 14, color: '#101828', whiteSpace: 'nowrap', position: 'sticky', top: 0, zIndex: 2 } },
      { props: { size: 'fibe', variant: 'body' }, style: { height: 44, padding: '0 16px', borderBottom: '1px solid #F0F1F4', fontWeight: 400, fontSize: 14, color: '#667085', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } },
    ],
  },
  MuiTableRow: {
    styleOverrides: {
      hover: { '&:hover': { backgroundColor: '#F2F2F2' } },
    },
  },
};

export default theme;
